import debounce from "debounce";
import { useContext, useEffect } from "react";
import config from "../../../../../config/app";
import { AppContext } from "../../../../lib/appContext";
import { MAX_REQUEST_WAIT, TIMEOUT_TICK } from "./constants";
import * as cookies from "./cookies";
import { sendRequest } from "./helpers";
import * as Snowplow from "./snowplow";

const { appName, appVersion, pageViewServiceUrl } = config;
const app = { name: appName, version: appVersion };

const CONCESSIONAIRE = "automotora";
const CONCESSIONAIRE_PATH = "/automotora";

const getReferrer = () =>
  window.location.href.includes(CONCESSIONAIRE_PATH) ? CONCESSIONAIRE : document.referrer;

export const useSendPageView = (setPageView: any) => {
  const { countryCode } = useContext(AppContext);

  const send = debounce((pageView: object) =>
    sendRequest(pageViewServiceUrl.first, pageView)
      .then(setPageView)
      .catch(() => setPageView(pageView))
  );

  return useEffect(() => {
    cookies.setCookies();
    const pageView = {
      app,
      compara: cookies.getComparaCookies(),
      countryCode,
      ga: {},
      pageURL: window.location.href,
      referrer: getReferrer(),
      snowplow: {}
    };

    send(pageView);

    if (window.ga) {
      window.ga((tracker: any) => {
        pageView.ga = { clientId: tracker.get("clientId") };
        send(pageView);
      });
    }

    /* eslint-disable @typescript-eslint/no-use-before-define */
    const clearAllTimers = () => {
      window.clearTimeout(timeout);
      window.clearInterval(interval);
    };

    const timeout = window.setTimeout(() => {
      send(pageView);
      window.clearInterval(interval);
    }, MAX_REQUEST_WAIT);

    const interval = (window.setInterval as any)(() => {
      if (!window.co_snowplow) {
        pageView.snowplow = { error: "The sp.js script did not init" };
        send(pageView);
        clearAllTimers();
        return;
      }

      window.co_snowplow(function(this: any) {
        if (this.cf) {
          const userId = this.cf.getUserId();
          const domainUserInfo = this.cf.getDomainUserInfo();
          pageView.snowplow = Snowplow.build(userId, domainUserInfo);

          send(pageView);
          clearAllTimers();
        }
      });
    }, TIMEOUT_TICK);
    /* eslint-disable */
  }, []);
};
